// extracted by mini-css-extract-plugin
module.exports =  {"index":"e2ff468f85--index--W0QQl"};